(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportLineDialogController', MedReportLineDialogController);

    MedReportLineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MedReportLine', 'MedReport', 'Medicine'];

    function MedReportLineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MedReportLine, MedReport, Medicine) {
        var vm = this;
        vm.medReportLine = entity;
        vm.medreports = MedReport.query();
        vm.medicines = Medicine.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:medReportLineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.medReportLine.id !== null) {
                MedReportLine.update(vm.medReportLine, onSaveSuccess, onSaveError);
            } else {
                MedReportLine.save(vm.medReportLine, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
